// extracted by mini-css-extract-plugin
export default {"addButton":"StudentsTable_addButton__-fzzT","searchField":"StudentsTable_searchField__EcLfl"};